import { useState, useEffect } from "react";

const useMobileOrientation = () => {
  const getOrientation = () => {
    if (window.screen.orientation) {
      return window.screen.orientation.type.startsWith("landscape")
        ? "landscape"
        : "portrait";
    }

    return window.innerWidth > window.innerHeight ? "landscape" : "portrait";
  };

  const [orientation, setOrientation] = useState(getOrientation());

  useEffect(() => {
    const handleChange = () => {
      setOrientation(getOrientation());
    };

    window.addEventListener("resize", handleChange);
    window.addEventListener("orientationchange", handleChange);
    return () => {
      window.removeEventListener("resize", handleChange);
      window.removeEventListener("orientationchange", handleChange);
    };
  }, []);

  const isLandscape = orientation === "landscape";
  const isPortrait = orientation === "portrait";

  return {
    orientation,
    isLandscape,
    isPortrait,
  };
}

export default useMobileOrientation;